import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `POST …/validations` — no body. */
class ValidateDocument {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
	) {
		Object.freeze(this);
	}
}

export default ValidateDocument;
